/**
 * Obtiene todas las filas de un endpoint paginado (máx. `pageSize` por petición, p. ej. 500 en backend).
 */
export async function fetchAllPagesData<T>(
  fetchPage: (args: { page: number; limit: number }) => Promise<{ data?: T[]; totalPages?: number }>,
  pageSize = 500,
): Promise<T[]> {
  const first = await fetchPage({ page: 1, limit: pageSize });
  const items: T[] = [...(first.data ?? [])];
  const totalPages = Math.max(1, first.totalPages ?? 1);
  for (let p = 2; p <= totalPages; p++) {
    const next = await fetchPage({ page: p, limit: pageSize });
    items.push(...(next.data ?? []));
  }
  return items;
}
